import type { NavigationActionItem } from "./navigation-action.type";

import { InfoCircleOutlined, LogoutOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import { useAboutModal } from "@/modules/about-modal";
import { useAuthLogout } from "@/services/auth";

export const useNavigationActionAbout = (): NavigationActionItem => {
  const { t } = useTranslation();
  const { openAboutModal } = useAboutModal();

  return {
    key: "about",
    text: t("navigation:about"),
    icon: <InfoCircleOutlined />,
    runAction: openAboutModal,
  };
};

export const useNavigationActionLogout = (): NavigationActionItem => {
  const { t } = useTranslation();
  const logout = useAuthLogout();

  return {
    key: "logout",
    text: t("navigation:logout"),
    icon: <LogoutOutlined />,
    runAction: logout,
  };
};
